<template>
  <div class="d-flex">
    <v-text-field
      v-model="quantityBet"
      class="ml-2"
      label="Outlined"
      placeholder="qtd. Apostas"
      solo-inverted
      :prefix="$t('until')"
      :suffix="$t('bets')"
      dense
      hide-details
      @change="setQuantityBet"
      type="number"
    ></v-text-field>
  </div>
</template>
<script>
export default {
  name: "components-common-filters-quantity-bet",
  data: () => ({
    quantityBet: 10,
  }),
  methods: {
    setQuantityBet(quantityBet) {
      this.$store.commit("setQuantityBet", quantityBet);
    },
  },
};
</script>
